import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import TranslationUtil from '../../utils/TranslationUtil';
import { pathSources } from '../../constants/common';

export const ProgressBarLYP = ({
    stepCopy, hide
}) => (hide ? null : (
    <div className="ulx-stepper" id="ulx-step-indicator" data-wdio="lyp-progress-bar">
        {stepCopy}
    </div>
));

ProgressBarLYP.propTypes = {
    stepCopy: PropTypes.string.isRequired,
    hide: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const { app } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const { step } = ownProps;
    const maxSteps = 3; // We should probably generate this from pageflow somehow in the future
    const stepCopyProps = {
        step,
        maxSteps
    };
    return {
        stepCopy: translations.getTranslation('lyp.header.progress', stepCopyProps),
        hide: app.pathSource !== pathSources.ULX && !app.featues?.isFrboFlow
    };
};

ProgressBarLYP.displayName = 'ProgressBarLYP';
export default hot(module)(connect(mapStateToProps)(ProgressBarLYP));
